import React from 'react'
import styled from 'styled-components'
import omit from 'lodash.omit'
import {
  Button,
  Container,
  Navbar,
  NavbarBrand
} from 'reactstrap'

const LogoutButton = styled(Button)`
  cursor: pointer;
`

const Admin = props => {
  const passingProps = omit(props, ['children'])

  return (
    <Container>
      <div>
        <Navbar color='light' light expand='md' className='mb-3 justify-content-between'>
          <NavbarBrand href='/admin'>Atlas Agropecuário - Área Privada</NavbarBrand>
          <LogoutButton className='rounded-0' onClick={props.logout}>Logout</LogoutButton>
        </Navbar>
        {React.cloneElement(props.children, passingProps)}
      </div>
    </Container>
  )
}

export default Admin



// WEBPACK FOOTER //
// ./src/components/templates/Admin/Admin/Admin.js